import React from 'react';
import { Form } from 'react-bootstrap';
import { TableSkeletonRows } from '../loader';
import { TablePagination } from './TablePagination';
import { EmptyTableState } from './EmptyTableState';
import { StyledTable, StyledTableHeader, StyledTableCell, StyledTableRow } from './StyledTable';

/*
  Props:
    columns: [{ header: 'Name', accessor: 'name', render: (row)=>... }]
    data: array
    loading: bool
    searchValue: string
    onSearch: (val) => void
    filters: [{ key, label, options, value, onChange }]
    pagination: { activePage, itemsPerPage, totalItems, onChange }
    tableProps: any (className, responsive, etc.)
*/
export default function ReusableTable({
  columns = [],
  data = [],
  loading = false,
  searchValue = '',
  onSearch = () => {},
  filters = [],
  pagination = null,
  tableProps = {},
}) {
  return (
    <>
      <div className="premium-filter-card">
        <div className="search-top-right">
          <i className="fa fa-search" aria-hidden="true"></i>
          <Form.Control
            placeholder="Search…"
            value={searchValue}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        {filters.map((f) => (
          <select
            key={f.key}
            className="filter-select"
            aria-label={f.label}
            value={f.value}
            onChange={(e) => f.onChange && f.onChange(e.target.value)}
          >
            <option value="">{f.label}</option>
            {f.options && f.options.map((opt) => (
              <option key={opt.value ?? opt} value={opt.value ?? opt}>{opt.label ?? opt}</option>
            ))}
          </select>
        ))}
      </div>

      <div className="audit-request-box premium-company-card">
        <StyledTable responsive="sm" {...tableProps}>
          <thead>
            <StyledTableRow>
              {columns.map((col, idx) => (
                <StyledTableHeader key={idx}>{col.header}</StyledTableHeader>
              ))}
            </StyledTableRow>
          </thead>
          <tbody>
            {loading ? (
              <TableSkeletonRows rows={pagination?.itemsPerPage || 8} columns={columns.length} />
            ) : data && data.length > 0 ? (
              data.map((row, rIdx) => (
                <StyledTableRow key={row._id ?? rIdx}>
                  {columns.map((col, cIdx) => (
                    <StyledTableCell key={cIdx}>
                      {col.render ? col.render(row) : (row[col.accessor] ?? '-')}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <EmptyTableState colSpan={columns.length} />
            )}
          </tbody>
        </StyledTable>

        {pagination && (
          <TablePagination
            activePage={pagination.activePage}
            itemsCountPerPage={pagination.itemsPerPage}
            totalItemsCount={pagination.totalItems}
            onChange={pagination.onChange}
          />
        )}
      </div>
    </>
  );
}
